<p-toast></p-toast>
<div class="mw-100" style="background-color: white; height: 100%;">
    <app-navbar></app-navbar>
    <div class="container">
      <div class="button" style="margin-left: 15px;">
        <button class="p-button p-component btn" (click)="regresar(deviceUrl, deviceName)">Menu</button>
    </div>
    <app-device-status-message [deviceUrl]="deviceUrl"></app-device-status-message>
      <form autocomplete="off" class="form-horizontal" enctype="multipart/form-data" (ngSubmit)="enviarArchivo()">
        <div class="p-card p-component">
          <div class="p-card-header p-component p-card-header-primary">
            <h5 class="pdfs-15">{{ 'PERSONALIZED_FILE_MULTIPLE_CONTACTS' | translate}}</h5>
          </div>
          <div class="p-card-body p-component">
             <!-- Opción de ingreso por CSV -->
            <div class="p-grid">
              <div class="p-col-3">
                <div class="p-formgroup-inline">
                  <div class="p-field-checkbox">
                    <input type="radio" name="opcionLista" value="2" id="opc2" class="p-radiobutton-input" checked="true">
                    <label class="customfont1" for="opc2">{{ 'CSV_IMPORT_FILE' | translate}}</label>
                  </div>
                </div>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                    <input class="p-inputtext p-component inputfiled" name="txt-archivoTelefonos" id="txt-archivoTelefonos" type="file" aria-required="true" (change)="onFileSelected($event)"/>
                    <a class="descargarCSV" href="../../../../assets/ejemplo3/ejemplo.csv" download>{{ 'EXAMPLE_SELECTED_FILE' | translate}}</a>
                </div>
              </div>
            </div>
            <!-- Nombre de la campaña -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'CAMPAIGN_NAME_FILE' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <input class="p-inputtext p-component inputfiled" name="txt-nombreCapaña" id="txt-campaña" type="text" 
                  placeholder="{{ 'NAME_CAMPAIGN_FILE' | translate}}" aria-required="true" required [(ngModel)]="camposMensaje.nombreCampania"/>     
                  <!--Validación campo-->
                  <div *ngIf="validar && !camposMensaje.nombreCampania">
                    <div class="alerta">
                      <span>{{ 'REQUIRED_FILE' | translate}}</span>
                    </div>
                  </div>
                <!--Validación campo-->            
                </div>
              </div>
            </div>
            <!-- Nombre del archivo -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'FILE_NAME_FILE' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <input class="p-inputtext p-component inputfiled" name="txt-nombreArchivo" id="txt-nombreArchivo" type="text" 
                  placeholder="{{ 'FILE_FIELD_FILE' | translate}}" aria-required="true" required  [(ngModel)]="camposMensaje.nombrearchivo"/>                
                  <!--Validación campo-->
                  <div *ngIf="validar && !camposMensaje.nombrearchivo">
                    <div class="alerta">
                      <span>{{ 'REQUIRED_FILE' | translate}}</span>
                    </div>
                  </div>
                <!--Validación campo-->
                </div>
              </div>
            </div>
            <!--Mensaje -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'MESSAGE_TITLE_FILE' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">                
                  <textarea class="p-inputtext p-component inputfiled" name="txt-telefonos" id="txt-telefonos" rows="10" required resize="none"
                  placeholder="{{ 'CUSTOM_TEXT_FILE' | translate}}"
                  [(ngModel)]="camposMensaje.textoimagen"></textarea>    
                  <!--Validación campo-->
                  <div *ngIf="validar && !camposMensaje.textoimagen">
                    <div class="alerta">
                      <span>{{ 'REQUIRED_FILE' | translate}}</span>
                    </div>
                  </div>
                <!--Validación campo-->        
                </div>
              </div>
            </div>
            <!--Mensaje -->
            <div class="p-grid">
              <div class="p-col-3">
                <label class="customfont1">{{ 'WEBHOOK_FILE' | translate}}</label>
              </div>
              <div class="p-col-7">
                <div class="p-field p-fluid">
                  <input class="p-inputtext p-component inputfiled" name="txt-webhook" id="txt-webhook" type="text" 
                  placeholder="https://webhook.site/" aria-required="true" required/>                
                </div>
              </div>
            </div>
  
          </div>
          <div class="p-card-footer ml-auto mr-auto boton">
            <button type="submit" class="p-button p-component btn">{{ 'SEND_FILE' | translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
